export const TEMPLATE_ROW_MOBILE_MAX_WIDTH = 1020

export const OFFER_FEATURES_VALUES = {
  BIDMARKET: 'BIDMARKET',
}
